// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__1ZWe8","resize":"app_resize__2Kzcv","line":"app_line__1sNXQ","body":"app_body__1DfIV","footer":"app_footer__1B34Y","edit":"app_edit__3X8FM","view":"app_view__2TwIj"};